<div class="sidebar-panel"
>
  <div id="sidebar-top-scroll-area" [perfectScrollbar] class="navigation-hold" fxLayout="column">
    <app-sidenav [items]="menuItems" style="background-color: #ee5c68;"></app-sidenav>
  </div>
</div>
